let SOCoupons = (function() {
    let setSlider = function(){
        jQuery('#coupon-slider').slick({
            dots: true,
            arrows: true,
            adaptiveHeight: true,
            slidesToShow: 1,
            prevArrow: '<i class="fa fa-chevron-left slick-prev"></i>',
            nextArrow: '<i class="fa fa-chevron-right coupon-slick-next slick-next"></i>', 
            appendArrows: '#coupon-slider-nav',
            appendDots: '#coupon-slider-nav'
        });
        jQuery('#coupon-slider-nav .coupon-slick-next').detach().insertAfter('#coupon-slider-nav .slick-dots');


        jQuery('#campaign-slider').slick({
            dots: true,
            arrows: true,
            adaptiveHeight: true,
            slidesToShow: 1,
            prevArrow: '<i class="fa fa-chevron-left slick-prev"></i>',
            nextArrow: '<i class="fa fa-chevron-right coupon-slick-next slick-next"></i>', 
            appendArrows: '#campaign-slider-nav',
            appendDots: '#campaign-slider-nav'
        });
        jQuery('#campaign-slider-nav .coupon-slick-next').detach().insertAfter('#campaign-slider-nav .slick-dots');
    }
    return {
        setSlider: setSlider
    };
  })();